export const getQueriesInitialState = {
	queries: null,
	error: null,
	errorShow: false,
	loading: false,
};
